import { Component, OnDestroy, OnInit, Output } from "@angular/core";
import { filter, Observable, Subject, Subscription, take } from "rxjs";
import { RouteMapService } from "../../../../services/RouteMap.service";
import { Router } from "@angular/router";
import { PopupDetailGeoposService } from "../../../../services/Popup-Detail-Geopos.service";
import { LocationsService } from "src/app/features/map-features/sections/locations-section/services/Locations.service";
import { TutorialService } from "src/app/features/ui/organisms/tutorial/services/tutorial.service";
import { NotificationsToastService } from "src/app/features/shared/services/Notifications-Toast.service";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { RouteFilterService } from "../../../../services/Route-Filter.service";
import { MapHelperService } from "src/services/map-helper.service";
import { environment } from "src/environments/environment";
import { LayerService } from "src/app/features/map-features/sections/locations-section/services/Layers.service";
import { BaseMapService } from "src/app/features/pages/maps/services/BaseMap.service";
@Component({
  selector: "route-section",
  templateUrl: "./route-section.component.html",
  styleUrls: ["./route-section.component.css"],
})
export class RouteMapComponent implements OnInit, OnDestroy {
  $data: [];
  private _baseMap: string;
  public _isVisibleDetails: boolean;
  public _isVisiblePinbar: boolean;
  public _isVisiblePanel: boolean;
  public _IsAuthenticated: boolean = false;
  public _baseMapText: string = "Modo Nocturno";
  public _isVisiblePopUpMap: boolean;
  public $isVisiblePopUpMap: Observable<boolean>;
  public isLoading: boolean = false;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  public isMapUnified: boolean = false;
  public recargarHora: number = 0;
  private id$: Subject<string> = new Subject<string>();
  $dataGeoJson: any;
  public isMapix: boolean = false;
  isAdmin: boolean;
  $isVisiblePanel: Observable<boolean> = new Observable<boolean>();

  
  subscription_SetLocationsGeoJSON: Subscription;
  subscription_isVisiblePopUpMap: Subscription;
  subscription_getLoading: Subscription;
  subscription_isVisiblePanel: Subscription;
  Subscription_GetMapMainSource: Subscription;

  private _CENTER_LAT = "24.226252";
  private _CENTER_LNG = "-103.0266765";
  private _CENTER_ZOOM = "4.5";

  constructor(
    private mapHelperService: MapHelperService,
    private routeMapService: RouteMapService,
    private locationsService: LocationsService,
    private popupDetailGeoposService: PopupDetailGeoposService,
    private routeFilterService: RouteFilterService,
    private router: Router,
    private notificationsToastService: NotificationsToastService,
    private sessionService: SessionService,
    private tutorialService: TutorialService,
    private layerService : LayerService,
    private baseMapService: BaseMapService,
  ) {
    
    this.$isVisiblePopUpMap = this.popupDetailGeoposService.checkVisibilityPopup();
    this.subscription_isVisiblePopUpMap = this.$isVisiblePopUpMap.subscribe((data) => {
      this._isVisiblePopUpMap = data;
    });
    this.subscription_getLoading = this.routeMapService.getLoading().subscribe((data: boolean) => {
      this.isLoading = data;
    });
    this.$isVisiblePanel = this.routeFilterService.getVisibilityPanel();
    this.subscription_isVisiblePanel = this.$isVisiblePanel.subscribe((element) => {
      this._isVisiblePanel = element;
      setTimeout(() => {
        if (this._isVisiblePanel != undefined && this._isVisiblePanel == true) {
          this.tutorialService.startTutorial(["panelRouteControlTutorial"]);
        }
      }, 1000);
    });
    this.isMapUnified = false;
  }

  ngOnInit(): void {
    this.startMap();
    //this.getLastsGeoPosLocations();
    this.checkURLSource();
  }


  ngOnDestroy() {
    if (this.subscription_SetLocationsGeoJSON)
      this.subscription_SetLocationsGeoJSON.unsubscribe();
    if (this.subscription_isVisiblePopUpMap)
      this.subscription_isVisiblePopUpMap.unsubscribe();
    if (this.subscription_getLoading)
      this.subscription_getLoading.unsubscribe();
    if (this.subscription_isVisiblePanel)
      this.subscription_isVisiblePanel.unsubscribe();
    if (this.Subscription_GetMapMainSource)      
      this.Subscription_GetMapMainSource.unsubscribe();
  }

  checkURLSource() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  checkVisibilityDetails() {
    if(!environment.production) console.log("emitter received routeDetails");
    this._isVisibleDetails = true;
  }

  startMap() {
    this._isVisiblePinbar = true;
    this._isVisibleDetails = false;
    this._isVisiblePanel = false;
    // this.routeMapService.LoadRouteMap();

    this.Subscription_GetMapMainSource = this.mapHelperService.mainSource$.pipe(
        filter(map => map && map.isMainSourceReady && map.isStyleReady), take(1) ).subscribe(async map => {
      if (map && map.isMainSourceReady && map.isStyleReady ) {
        this.routeMapService.LoadRouteMap();
    
        this.mapHelperService.mapResize();
      }
    });

    // this.baseMapService.addEventOnMapLoad(async () => {
    //   this.routeMapService.LoadRouteMap();
    // });
  }

  // getLastsGeoPosLocations() {
  //   this.routeMapService.setLoading(true);
  //   if(!environment.production) console.log("GetLastsGeoJson");
  //   setTimeout(() => {
  //     this.subscription_SetLocationsGeoJSON = this.layerService.GetLayerGPSGeoJson().subscribe(
  //         (data: EstatusJSON) => {
  //           if (data.isSuccess == true) {
  //             this.$dataGeoJson = JSON.parse(data.result);
  //             this.mapHelperService.UpdateLayerGeoJson(
  //               "LastGeoPositions",
  //               this.$dataGeoJson
  //             );
  //             this.routeMapService.setLoading(false);
  //           } else {
  //             // this.notificationsToastService.showErrorSystem();
  //             Sentry.captureMessage('RouteSection.getLastsGeoPosLocations: respuesta sin éxito', { level: 'warning', extra: { response: data } });
  //             console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
  //             this.routeMapService.setLoading(false);
  //           }
  //         },
  //         (error) => {
  //           // this.notificationsToastService.showErrorSystem();
  //           console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
  //           this.routeMapService.setLoading(false);
  //         }
  //       );
  //   }, 1500);
  // }
}
